import { useMemo } from 'react';

import { useQuery } from '@apollo/react-hooks';
import { isNil } from 'lodash-es';

import { IHistoricalOrder } from '@rbi-ctg/menu';
import { GetUserOrderQuery, IGetUserOrder, IGetUserOrderInput } from 'remote/queries/user-orders';
import { useAuthContext } from 'state/auth';
import { stripTypename } from 'state/graphql/links/strip-typename';

export const useOrderDetails = (rbiOrderId?: string | null) => {
  const { isAuthenticated } = useAuthContext();
  const { data, error, loading, refetch } = useQuery<IGetUserOrder, IGetUserOrderInput>(
    GetUserOrderQuery,
    {
      variables: {
        id: rbiOrderId!
      },
      skip: isNil(rbiOrderId) || !isAuthenticated()
    }
  );

  const order = useMemo<IHistoricalOrder | null>(() => (data ? stripTypename(data.order) : null), [
    data
  ]);

  return { error, loading, order, refetch: isAuthenticated() ? refetch : () => Promise.resolve() };
};
